import { v4 as uuidv4 } from "uuid";
import { hasMarketingConsent } from "./consent";

export const logCustomEvent = (
  eventName: string,
  params?: Record<string, any>,
) => {
  window?.gtag && window.gtag("event", eventName, params);
  logBingEvent(eventName, params);
};

export const logBingEvent = (e: string, p?: { [key: string]: string }) => {
  window.uetq = window.uetq || [];
  if (p) window.uetq.push("event", e, p);
  else window.uetq.push("event", e);
};

export const logOpenAIEvent = (
  eventName: string,
  data?: Record<string, unknown>,
) => {
  if (!window.oaiq || !hasMarketingConsent()) return;
  window.oaiq(
    "measure",
    eventName,
    { type: "customer_action", ...data },
    { event_id: uuidv4() },
  );
};
